module.exports = __webpack_public_path__ + "media/images/header-bg-f5c0e8a3ed21c87e5f52134c446e3258.jpg";